import React from 'react';
import { useSession } from 'src/SessionContext';
import ContainerSpinner from 'src/ui-components/ContainerSpinner';
import TalentView from './components/TalentView';

const TalentPage: React.FC = () => {
  const { session, loading } = useSession() || {};
  const { dayliteId } = session || {};

  if (loading || !dayliteId) {
    return <ContainerSpinner />;
  }

  return <TalentView talentId={dayliteId}/>;
};

export default TalentPage;
